import { Layout, Page, usePath } from "@fdoh/health-ui-react";
import { useHistory, useLocation } from "react-router-dom";
import UserForm from "../UserForm";
import ApplicationDetailsPage from "../Home/ApplicationDetails";
import { UserInput } from "../UserForm.types";
import { useData } from "../../../hooks";

// TODO: Add error handling



const EditUserPage = () => {
    const path = usePath();
   // const { search } = useLocation();
   // const searchParams = new URLSearchParams(search);
    //const applicationId = JSON.parse(searchParams.get("applicationId") || '{}');
    const val = path.current.substring(path.current.lastIndexOf('/')+1);
  
    const data = useData<UserInput>("UserSecurity/"+val) ;
   
  return data  ? (
      <Page.Container>
      <Page.Body>
        <Layout.Container>
                  <UserForm
                      id="editUserForm"
                      title="Edit User Form"
            action="post"
            returnPath={`/userManagement`}
            values={data}
          />
        </Layout.Container>
      </Page.Body>
    </Page.Container>
  ): <Page.Container>
  <Page.Header preTitle="Private Provider Inspection" title="Welcome" />
  <Page.Body>
      <Layout.Container>
          <div className="row row-dec row-cards">
              <div className="col-lg-12">
               
              </div>
          </div>
      </Layout.Container>
  </Page.Body>
</Page.Container>;
};

export default EditUserPage;